// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"240":"support","806":"user","933":"auth"}[chunkId] + "." + {"240":"7baf2fa4","806":"7919f247","933":"9347a21b"}[chunkId] + ".js";
};